var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapGraduation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100.353 100.353",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.54,33.012L49.476,5.636c-0.504-0.336-1.16-0.336-1.664,0L6.748,33.012C6.331,33.29,6.08,33.759,6.08,34.26  s0.25,0.97,0.668,1.248l6.237,4.158v21.913c0,0.511,0.26,0.987,0.69,1.263l34.399,22.053c0.247,0.158,0.528,0.237,0.81,0.237  c0.295,0,0.591-0.087,0.845-0.261l17.947-12.244v8.538L60.99,94.537c-0.232,0.465-0.207,1.018,0.065,1.46  c0.273,0.441,0.757,0.711,1.276,0.711H76.02c0.52,0,1.003-0.27,1.276-0.711c0.272-0.442,0.298-0.995,0.065-1.46l-6.686-13.372V70.58  l11.377-7.762c0.409-0.279,0.654-0.743,0.654-1.239V40.73l7.833-5.222c0.417-0.278,0.668-0.747,0.668-1.248  S90.957,33.29,90.54,33.012z M64.759,93.708l4.417-8.834l4.417,8.834H64.759z M48.858,81.834L15.985,60.759V41.666l31.827,21.219  c0.252,0.168,0.542,0.252,0.832,0.252s0.58-0.084,0.832-0.252l18.2-12.134v18.244L48.858,81.834z M79.707,60.787l-9.031,6.162  V48.751l9.031-6.021V60.787z M80.686,38.472c-0.221,0.082-0.416,0.213-0.574,0.383l-10.936,7.291l-19.7-13.134  c-0.691-0.46-1.621-0.273-2.08,0.416c-0.459,0.689-0.273,1.621,0.416,2.08l18.66,12.44L48.644,59.834L10.284,34.26l38.36-25.573  l38.36,25.573L80.686,38.472z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapGraduation);
export default __webpack_public_path__ + "static/media/cap-graduation.d8ecb89e06e6a0165f9ae9af5f5e120a.svg";
export { ForwardRef as ReactComponent };